import React, { useEffect, useState } from 'react'
import { Row, Col, Container } from 'react-bootstrap';
import DoneSurveyCard from '../components/DoneSurveyCard';
import { getDoneSurveyAPI } from '../api/doneSurveyAPI';
import { SurveyItem } from '../types/index.ts'
export default function DoneSurveys() {
 
    const [pendingSurveys, setPendingSurveys] = useState<SurveyItem[]>([]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                await searchDoneSurvey();
            } catch (error) {
                console.error(error);

            } finally {
                console.log("loaded");
            }
        }

        fetchData()
    }, [])


    const searchDoneSurvey = () => {
        getDoneSurveyAPI()
            .then(response => {
                setPendingSurveys(Array.isArray(response) ? response : []);
            })
            .catch(error => {
                console.error('Error fetching done surveys', error);
            });

    }

    return (
        <Container>
            {pendingSurveys.map((survey) => (
                <Row key={survey.id} className="p-3 d-flex justify-content-start p-0"  >
                    <Col>
                        <DoneSurveyCard survey={survey} />
                    </Col>
                </Row>
            ))}

        </Container>


    );
   
   
}